/**
 * Extracts a user-friendly error object from an Axios error response.
 *
 * @param {object} axiosError - The caught error from axios (error.response?.data)
 * @returns {{ message: string, errorCode: string | null }}
 */
const ERROR_MESSAGES = {
  error_login_failed: "Anmeldung fehlgeschlagen. Bitte prüfe deine Login-Daten und versuche es erneut.",
  error_wrong_otp: "Der von dir eingegebene Verifizierungscode ist falsch. Bitte prüfe ihn und versuche es erneut.",
  error_wrong_otp_email: "Der von dir eingegebene E-Mail-Verifizierungscode ist falsch. Bitte prüfe ihn und versuche es erneut.",
  error_expired_otp: "Der Verifizierungscode ist abgelaufen. Bitte gehe zurück und fordere einen neuen an.",
  error_mobile_phone_taken: "Die Telefonnummer ist bereits mit einem anderen Konto verbunden.",
  error_schufa_input_invalid: "Einige deiner Angaben scheinen falsch zu sein. Bitte gehe zurück und überprüfe sie.",
  error_schufa_verification_failed: "Deine Daten wurden nicht erfolgreich verifiziert. Bitte überprüfe die angegebenen Daten und versuche es erneut.",
  error_email_validation_failed: "Die E-Mail konnte an die angegebene Adresse nicht zugestellt werden. Bitte überprüfe die Adresse und versuche es noch einmal.",
  error_email_address_blacklisted: "Die eingegebene E-Mail-Adresse ist nicht erlaubt. Nutze bitte eine echte E-Mail-Adresse und versuche es erneut.",
  error_input_invalid: "Einige deiner Angaben scheinen falsch zu sein. Bitte gehe zurück und überprüfe sie.",
  error_consumer_already_exists: "Ein Konto mit dieser E-Mail-Adresse existiert schon; bitte melden Sie sich an oder setzen Sie Ihr Passwort zurück, falls Sie es vergessen haben.",
  error_consumer_password_not_allowed: "Das Passwort wurde bereits unter den letzten 10 Passwörtern verwendet. Bitte wählen Sie ein neues Passwort."
};

const GENERIC_MESSAGE = "Einige deiner Angaben scheinen falsch zu sein. Bitte gehe zurück und überprüfe sie.";

export function extractApiError(responseData) {
  const errorCode = responseData?.meta?.ts || null;
  const errorIdent = responseData?.data?.error || null;
  const message = ERROR_MESSAGES[errorIdent] || GENERIC_MESSAGE;

  return { message, errorCode };
}
